import { GET_ALL_HOLIDAYS, GET_ALL_LEAVE_RECORD } from "../../actionTypes";

const initialState = {
  allRequest: [],
  requestTypes: [],
  leaveRecords: [],
  next: "",
  prev: "",
  currentPage: 1,
  last: null,
};

export const holidaysMngtReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_HOLIDAYS:
      return {
        ...state,
        allRequest: payload.request.data || [],
        requestTypes: payload.requestType,
        next: payload.request.next_page_url,
        prev: payload.request.prev_page_url,
        last: payload.request.last_page,
        currentPage: payload.request.current_page,
      };

    case GET_ALL_LEAVE_RECORD:
      return {
        ...state,
        leaveRecords: payload.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/holidaymanagement/holiday.reducers.js